<span *ngIf="product.deliveryTimeInDays < 10; else weeks">
    {{ deliveryTimeDaysText  | translate: {dayUnit: product.deliveryTimeInDays | deliveryDateConversion} }}
</span>
<ng-template #weeks>
  <span>
    {{ deliveryTimeWeeksText  | translate: {dayUnit: product.deliveryTimeInDays | deliveryDateConversion} }}
  </span>
</ng-template>
